import React from "react";
import { Helmet } from "react-helmet-async";

export default function KeyholdingPolicies() {
  return (
    <div className="min-h-screen bg-[#111111] text-white">
      <Helmet>
        <title>Keyholding Policies | SeguraTech</title>
        <meta
          name="description"
          content="An overview of the policies that govern SeguraTech Secure Keyholding, designed to ensure safety, accountability, and clarity."
        />
      </Helmet>

      {/* Page header */}
      <section className="max-w-6xl mx-auto px-4 pt-20 pb-12">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl font-extrabold text-[#C6A564] mb-6">
            Keyholding Policies
          </h1>
          <p className="text-lg text-white/80">
            To ensure safety, accountability, and clarity, our Secure Keyholding
            service operates under a defined set of formal policies.
          </p>
        </div>
      </section>

      {/* Policy summaries */}
      <section className="max-w-6xl mx-auto px-4 pb-24">
        <div className="max-w-3xl mx-auto space-y-10 text-white/80">

          <div>
            <h2 className="text-xl font-semibold text-[#C6A564] mb-2">
              Secure Keyholding & Emergency Access Policy
            </h2>
            <p>
              This policy defines how the Secure Keyholding service is delivered,
              including eligibility, identity verification, attendance procedures,
              refusal conditions, and how exceptional situations are handled.
            </p>
            <p className="mt-2">
              It exists to ensure access is provided only to the verified account
              holder and only in accordance with agreed safeguards.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-[#C6A564] mb-2">
              Body-Worn Camera Use Policy
            </h2>
            <p>
              Body-worn cameras are used during attendances to support safety,
              transparency, and accountability for both customers and personnel.
            </p>
            <p className="mt-2">
              Recording is always declared and is used solely for evidential,
              safety, and dispute resolution purposes in line with data protection
              requirements.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-[#C6A564] mb-2">
              Recorded Communications Policy
            </h2>
            <p>
              Certain service-related telephone calls may be recorded to ensure
              accuracy, accountability, and a clear record of instructions or
              requests.
            </p>
            <p className="mt-2">
              Recordings are handled securely and retained only for defined and
              lawful purposes.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-[#C6A564] mb-2">
              Key Storage & Handling Policy
            </h2>
            <p>
              This policy governs how keys are received, stored, tracked, and used
              as part of the Secure Keyholding service.
            </p>
            <p className="mt-2">
              Keys are never labelled with property addresses, are never loaned or
              handed over, and remain under controlled custody at all times.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-[#C6A564] mb-2">
              Data Storage & Retention Policy
            </h2>
            <p>
              Personal data collected as part of the Secure Keyholding service is
              stored securely and retained only for defined periods based on its
              purpose.
            </p>
            <p className="mt-2">
              This policy supports compliance with UK data protection law and
              works alongside the SeguraTech Privacy Notice.
            </p>
          </div>

          <div className="pt-6 border-t border-white/10 text-white/70 text-sm">
            <p>
              Full policy documents form part of the Secure Keyholding Agreement
              and are provided to customers as part of the onboarding process.
              Copies may also be made available on request where appropriate.
            </p>
          </div>

        </div>
      </section>
    </div>
  );
}
